import {convertToInt} from '@utils/helpers';
import {ENCODER_TYPE_SPORTRADAR} from '@constants/variables';
import validators from '@utils/validators';

const validate = (values) => {
    const errors = {};

    Object.assign(errors, validators.required(values.encoder_type, 'encoder_type'));

    if (ENCODER_TYPE_SPORTRADAR === convertToInt(values.encoder_type)) {
        Object.assign(errors, validators.required(values.scoreboard_overlay_position, 'scoreboard_overlay_position'));

        if (values.trimming) {
            Object.assign(errors, validators.required(values.trimming_type, 'trimming_type'));
            Object.assign(errors, validators.required(values.trimming_start_margin, 'trimming_start_margin'));
            Object.assign(errors, validators.required(values.trimming_end_margin, 'trimming_end_margin'));
        }

        if (values.has_overlay_support) {
            Object.assign(errors, validators.required(values.overlay, 'overlay'));
        }

        if (values.has_ad_support) {
            Object.assign(errors, validators.required(values.ad_type, 'ad_type'));
        }
    }

    return errors;
};

export default validate;
